import { CURRENT_GROUPING_CHANGED } from './types';

export function changeCurrentGrouping(grouping) {
  return (dispatch) => {
    dispatch({ type: CURRENT_GROUPING_CHANGED, payload: grouping });
  };
}
